/* SANGI — theme.js */

// ── Header scroll ──────────────────────────────────────────
const header = document.getElementById('site-header');
window.addEventListener('scroll', () => {
  header?.classList.toggle('scrolled', window.scrollY > 50);
}, { passive: true });

// ── Mobile nav ─────────────────────────────────────────────
const navToggle = document.getElementById('nav-toggle');
const mobileNav = document.getElementById('mobile-nav');
navToggle?.addEventListener('click', () => {
  const open = mobileNav?.classList.toggle('open');
  navToggle.setAttribute('aria-expanded', open);
});

// ── Search bar ─────────────────────────────────────────────
const searchToggle = document.getElementById('search-toggle');
const searchBar    = document.getElementById('search-bar');
const searchClose  = document.getElementById('search-close');
searchToggle?.addEventListener('click', () => {
  searchBar?.classList.toggle('open');
  searchBar?.querySelector('input')?.focus();
});
searchClose?.addEventListener('click', () => searchBar?.classList.remove('open'));

// ── Cart drawer ────────────────────────────────────────────
const cartDrawer  = document.getElementById('cart-drawer');
const cartToggle  = document.getElementById('cart-toggle');
const cartClose   = cartDrawer?.querySelector('.cart-drawer__close');
const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');

function openCartDrawer() {
  cartDrawer?.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}
function closeCartDrawer() {
  cartDrawer?.classList.remove('open');
  document.body.style.overflow = '';
}
cartToggle?.addEventListener('click', openCartDrawer);
cartClose?.addEventListener('click', closeCartDrawer);
cartOverlay?.addEventListener('click', closeCartDrawer);

async function renderCartDrawer() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const itemsEl   = document.getElementById('cart-drawer-items');
    const footerEl  = document.getElementById('cart-drawer-footer');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:32px 0;color:#C8A09A;font-size:.88rem">Your bag is empty.</p>';
      footerEl.innerHTML = `<a href="/collections/all" style="display:block;text-align:center;font-family:\'Jost\',sans-serif;font-size:.68rem;font-weight:500;letter-spacing:.13em;text-transform:uppercase;padding:14px;background:#2E1614;color:#FDF4F2;margin-top:16px">Start Shopping</a>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div style="display:grid;grid-template-columns:80px 1fr;gap:14px;padding:16px 0;border-bottom:1px solid #EDD8D4">
        <img src="${item.image}" alt="${item.title}" style="width:100%;aspect-ratio:3/4;object-fit:cover;background:#F9EBE8">
        <div>
          <p style="font-size:.6rem;letter-spacing:.12em;text-transform:uppercase;color:#C8A09A;margin-bottom:3px">${item.product_type}</p>
          <p style="font-family:'DM Serif Display',serif;font-size:.9rem;font-weight:400;color:#2E1614;margin-bottom:4px">${item.product_title}</p>
          ${item.variant_title !== 'Default Title' ? `<p style="font-size:.72rem;color:#987068;margin-bottom:8px">${item.variant_title}</p>` : ''}
          <div style="display:flex;justify-content:space-between;align-items:center">
            <p style="font-size:.85rem;color:#2E1614">${formatMoney(item.final_line_price)}</p>
            <button onclick="removeFromCart('${item.key}')" style="font-size:.6rem;color:#C8A09A;text-decoration:underline;background:none;border:none;cursor:pointer">Remove</button>
          </div>
        </div>
      </div>`).join('');

    footerEl.innerHTML = `
      <div style="display:flex;justify-content:space-between;padding:16px 0 8px;font-size:.88rem">
        <span style="color:#987068">Subtotal</span>
        <span style="color:#2E1614;font-weight:500">${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" style="display:block;text-align:center;font-family:'Jost',sans-serif;font-size:.68rem;font-weight:500;letter-spacing:.13em;text-transform:uppercase;padding:14px;background:#2E1614;color:#FDF4F2;margin-top:8px;transition:background .3s">Checkout</a>
      <a href="/cart" style="display:block;text-align:center;font-size:.68rem;color:#987068;margin-top:10px">View Full Cart</a>`;
  } catch (err) { console.error('Cart error:', err); }
}

function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
}

async function removeFromCart(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  updateCartCount();
  renderCartDrawer();
}

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const el   = document.getElementById('cart-count');
    if (el) el.textContent = cart.item_count || '';
  } catch {}
}

// ── Product gallery ────────────────────────────────────────
const galleryMain  = document.getElementById('gallery-main');
const galleryThumbs = document.getElementById('gallery-thumbs');
if (galleryMain && galleryThumbs) {
  galleryThumbs.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const target = parseInt(thumb.dataset.target, 10);
      galleryMain.querySelectorAll('.gallery-slide').forEach((s, i) => {
        s.classList.toggle('gallery-slide--active', i === target);
      });
      galleryThumbs.querySelectorAll('.gallery-thumb').forEach((t, i) => {
        t.classList.toggle('gallery-thumb--active', i === target);
      });
    });
  });
}

// ── Qty controls ───────────────────────────────────────────
const qtyInput  = document.getElementById('qty-input');
const qtyMinus  = document.getElementById('qty-minus');
const qtyPlus   = document.getElementById('qty-plus');
qtyMinus?.addEventListener('click', () => {
  const v = parseInt(qtyInput.value, 10);
  if (v > 1) qtyInput.value = v - 1;
});
qtyPlus?.addEventListener('click', () => {
  qtyInput.value = parseInt(qtyInput.value, 10) + 1;
});

// ── Variant selection ──────────────────────────────────────
const variantId = document.getElementById('variant-id');
document.querySelectorAll('.product-form input[type="radio"]').forEach(input => {
  input.addEventListener('change', () => {
    const form    = document.getElementById('product-form');
    const options = [...form.querySelectorAll('input[type="radio"]:checked')].map(i => i.value);
    const productJson = document.getElementById('product-json');
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const variant = product.variants.find(v =>
      options.every((opt, i) => v[`option${i+1}`] === opt)
    );
    if (variant && variantId) {
      variantId.value = variant.id;
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const addBtn = document.getElementById('add-to-cart');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
    }
  });
});

// ── AJAX Add to Cart ───────────────────────────────────────
const productForm = document.getElementById('product-form');
productForm?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const btn = document.getElementById('add-to-cart');
  btn.textContent = 'Adding…';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(document.getElementById('variant-id')?.value),
        quantity: parseInt(document.getElementById('qty-input')?.value || 1)
      })
    });
    if (res.ok) {
      btn.textContent = 'Added ✓';
      updateCartCount();
      setTimeout(() => { openCartDrawer(); btn.textContent = 'Add to Bag'; btn.disabled = false; }, 500);
    } else {
      btn.textContent = 'Add to Bag'; btn.disabled = false;
    }
  } catch {
    btn.textContent = 'Add to Bag'; btn.disabled = false;
  }
});

// ── Quick Add ──────────────────────────────────────────────
document.querySelectorAll('.prod-card__quick-btn').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    const pid = btn.dataset.productId;
    btn.textContent = 'Adding…';
    try {
      const res     = await fetch(`/products/${pid}.js`);
      const product = await res.json();
      const variant = product.variants.find(v => v.available) || product.variants[0];
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
      btn.textContent = 'Added ✓';
      updateCartCount();
      setTimeout(() => { openCartDrawer(); btn.textContent = 'Quick Add'; }, 500);
    } catch { btn.textContent = 'Quick Add'; }
  });
});

// ── Product filter pills ───────────────────────────────────
const filterPills = document.querySelectorAll('.filter-pill');
const prodGrid    = document.getElementById('prod-grid');
filterPills.forEach(pill => {
  pill.addEventListener('click', () => {
    filterPills.forEach(p => p.classList.remove('filter-pill--active'));
    pill.classList.add('filter-pill--active');
    const filter = pill.dataset.filter;
    prodGrid?.querySelectorAll('.prod-card').forEach(card => {
      if (filter === 'all' || card.dataset.category === filter) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
});

// ── Cart page qty & remove ─────────────────────────────────
document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key   = btn.dataset.key;
    const input = document.querySelector(`.qty-input[data-key="${key}"]`);
    if (!input) return;
    const delta = btn.classList.contains('cart-qty-plus') ? 1 : -1;
    const newQty = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = newQty;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    updateCartCount();
    if (newQty === 0) document.getElementById(`cart-item-${key}`)?.remove();
    const totals = await (await fetch('/cart.js')).json();
    document.querySelectorAll('.cart-summary__total span:last-child').forEach(el => {
      el.textContent = formatMoney(totals.total_price);
    });
  });
});

document.querySelectorAll('.cart-item__remove').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key = btn.dataset.key;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    document.getElementById(`cart-item-${key}`)?.remove();
    updateCartCount();
  });
});
